<script setup lang="ts">
import { formatPrice } from '#shared/utils/price'

const props = defineProps<{
  price: number | null
  originalPrice?: number | null
  discount?: number | null
  size?: 'sm' | 'md' | 'lg'
}>()

const priceSize = computed(() => ({
  sm: 'text-base font-bold',
  md: 'text-xl font-bold',
  lg: 'text-2xl font-bold',
}[props.size ?? 'md']))

const originalPriceSize = computed(() => ({
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
}[props.size ?? 'md']))
</script>

<template>
  <div class="flex items-baseline gap-2 flex-wrap">
    <span v-if="price != null" :class="[priceSize, 'text-primary-600 dark:text-primary-400']">
      {{ formatPrice(price) }}
    </span>
    <span v-else :class="[priceSize, 'text-gray-400']">
      Preço não informado
    </span>

    <span
      v-if="originalPrice && price != null && originalPrice > price"
      :class="[originalPriceSize, 'text-gray-400 line-through']"
    >
      {{ formatPrice(originalPrice) }}
    </span>

    <UBadge v-if="discount && discount > 0" color="error" size="sm" variant="soft">
      -{{ discount }}%
    </UBadge>
  </div>
</template>
